import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const Security = () => {
  return (
    <>
      <Subtitle>Security</Subtitle>
      <Paragraph>
        The security of your personal information and data is important to
        Glints. Glints will always strive to ensure that your personal
        information and data will be protected against unauthorized access.
        Glints has implemented appropriate electronic and managerial measures in
        order to safeguard, protect and secure your personal information and
        data.
      </Paragraph>
      <Paragraph>
        All personal information and data provided by you are only accessible by
        the authorized personnel of Glints or its authorized third parties, and
        such personnel shall be instructed to observe the terms of this Privacy
        Statement when accessing such personal information and data. You may
        rest assured that their personal information and data will only be kept
        for as long as is necessary to fulfill the purpose for which it is
        collected. You should safeguard your unique Username and Password by
        keeping it secret and confidential and never share these details with
        anyone.
      </Paragraph>
      <Paragraph>
        Glints uses a third party service provider to facilitate the electronic
        payment transactions on the Site.
      </Paragraph>
      <Paragraph>
        Glints follows generally accepted industry standards to protect the
        personal information and data submitted by you to the Site, both during
        transmission and once Glints receives it. However, no method of
        transmission over the Internet, or method of electronic storage, is 100%
        secure. Therefore, while Glints strives to protect your personal
        information and data against unauthorized access, Glints cannot
        guarantee its absolute security.
      </Paragraph>
    </>
  );
};
